import { SxProps } from '@mui/material';

export const titleSX: SxProps = {
	fontSize: { xs: 'var(--font-size-sm)', sm: 'var(--font-size-default)' },
	fontWeight: 'bold',
	textTransform: 'uppercase',
};
